import "react-lazy-load-image-component/src/effects/blur.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useParams } from "react-router-dom";
import Config from "../../config/Config";
import userIcon from "../../assets/images/icon_profile/user.svg";
import {
  DiagnosaIcon,
  InformasiIcon,
  RekamedisIcon,
  TindakanIcon,
} from "./icons";
import HealthIcon from "./mappingHealthIcon";
import SectionBox from "./sectionBox";
import { useEffect, useState } from "react";
import { getDataMedicalRecordDetail } from "../../core/service/api_medical_record";
import { setLoading } from "../../core/feature/config/configSlice";
import { useDispatch } from "react-redux";
import { formatDate, formatValue } from "./typeFormatter";

const getFileName = (value: any) => {
  if (typeof value !== "string" || !value) return "Unduh file";

  try {
    const fileName = decodeURIComponent(new URL(value, window.location.href).pathname)
      .split("/")
      .pop();

    return fileName || "Unduh file";
  } catch {
    return "Unduh file";
  }
};

const renderItemValue = (item: any) => {
  if (String(item?.type).toLowerCase() === "file" && item?.value) {
    return (
      <a
        href={item.value}
        download={getFileName(item.value)}
        className="text-blue-600 underline"
      >
        {getFileName(item.value)}
      </a>
    );
  }

  return formatValue(item?.value);
};

const Detailreport = (props: any) => {
  const dispatch = useDispatch();
  const [data, setData] = useState<any | null>(null);
  const { id } = useParams();

  const env = Config.BaseUrlDev;

  useEffect(() => {
    if (!id) return;
    dispatch(setLoading(true));
    getDataMedicalRecordDetail(id)
      .then((res: any) => {
        setData(res.data);
      })
      .catch((error: any) => {
        console.error("gagal ambil detail rekam medis", error);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  }, [id]);

  if (!data) {
    return null;
  }

  const activeTreatment = Object.entries(data?.treatmentData || {}).filter(
    ([, v]) => v === true
  );

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  return (
    <div className="relative min-h-screen h-full z-50 bg-psp-primary pb-10">
      <div className="min-h-screen h-full mb-6 px-4 py-6 bg-psp-primary top-to-bottom">
        <section className="mt-1 flex flex-col gap-3 mb-4">
          <div className="flex flex-row z-10 h-24 bg-white w-full rounded-3xl">
            <div className="relative w-20 h-20 bg-gray-200 my-auto rounded-xl ml-3">
              {data.photoUrl && (
                <img
                  src={getImgContent(data.photoUrl)}
                  alt=""
                  className="relative w-20 object-cover h-20"
                />
              )}
              {!data.photoUrl && (
                <img
                  src={userIcon}
                  alt=""
                  className="w-20 p-1 object-cover h-20"
                />
              )}
            </div>
            <div className="flex flex-row justify-between w-full">
              <div className="flex flex-col px-3 justify-center">
                <h1
                  className={`font-montserrat m-0 font-medium text-sm ${data.active ? "text-black" : "text-gray-500"
                    }`}
                >
                  {data.patientName?.length > 15
                    ? data.patientName.slice(0, 16) + "..."
                    : data.patientName ?? "-"}
                </h1>
                <h1
                  style={{ fontSize: 11 }}
                  className={`font-montserrat m-0 font-normal ${data.active ? "text-black" : "text-gray-500"
                    }`}
                >
                  NIS: {data.callerId}
                </h1>
              </div>
              <div className="flex flex-col justify-center items-center pr-4 mt-3">
                <HealthIcon size={48} score={data.healthScore} />
                <p className="text-center text-gray-400">{data.healthStatus}</p>
              </div>
            </div>
          </div>
        </section>

        {/* informasi umum */}
        <section className="mt-1 flex flex-col gap-3 mb-4">
          <SectionBox title="Informasi Umum" icon={<InformasiIcon />}>
            <p>Tanggal: {formatDate(data.createdAt)}</p>
          </SectionBox>
        </section>

        {/* rekam medis */}
        <section className="mt-1 flex flex-col gap-3 mb-4">
          <SectionBox title="Rekam Medis" icon={<RekamedisIcon />}>
            {data.fieldData ? (
              data.fieldData.map((item: any) => (
                <div key={item?.id} className="flex flex-wrap justify-between mb-2 border-b-[1px] border-gray-100">
                  <span className="truncate font-medium text-sm w-full">{item?.name}</span>
                  <span className="w-full text-right text-xs">{renderItemValue(item)}</span>
                </div>
              ))
            ) : (
              <p>Tidak ada data rekam medis</p>
            )}
          </SectionBox>
        </section>

        {/* diagnosa */}
        <section className="mt-1 flex flex-col gap-3 mb-4">
          <SectionBox title="Diagnosa" icon={<DiagnosaIcon />}>
            <p>{data.diagnosis}</p>
          </SectionBox>
        </section>

        {/* tindakan */}
        <section className="mt-1 flex flex-col gap-3 mb-4">
          <SectionBox title="Rencana Tindakan" icon={<TindakanIcon />}>
            {data?.treatmentData ? (
              data.treatmentData.map((item: any) => <div key={item?.id} className="mb-2">
                <p>{item?.name}</p>
                {
                  item.treatmentComplementData.map(
                    (subitem: any) => (
                      <p key={subitem?.id} className="ml-4">
                        • {subitem?.name}: {renderItemValue(subitem)}
                      </p>
                    )
                  )}
              </div>)
            ) : (
              <p>Tidak ada data tindakan</p>
            )}
          </SectionBox>
        </section>

        {/* attachment */}
        {/* <section className="mt-1 flex flex-col gap-3 mb-4">
          <SectionBox title="Attachment" icon={<TindakanIcon />}>
            <p>tes</p>
          </SectionBox>
        </section> */}
      </div>
    </div>
  );
};

export default Detailreport;
